module.exports = __webpack_public_path__ + "static/media/planner.59af5245.gif";